<template>
    <div>
        <banner :banner="banner"></banner>
        <div class="cates">
            <div class="catesCon">
                <div class="cateItem flx alc" v-for="item,index in cates">
                    <div class="cateName" :style=" index == 1?'' : 'letter-spacing: 2em;margin-right:0'" v-text="item.name"></div>
                    <div class="cateCon flx">
                        <div @click="scanThis(index,0)" class="caItem cursor" :class="index == 0?scans.industry_id == 0?'cactive' : '' : index == 1?scans.job_id == 0?'cactive' : '' : scans.sex == 0?'cactive' : ''">
                            全部
                        </div>
                        <div @click="scanThis(index,v.id)" class="caItem cursor" :class="index == 0?scans.industry_id == v.id?'cactive' : '' : index == 1?scans.job_id == v.id?'cactive' : '' : scans.sex == v.id?'cactive' : ''"  v-for="v,i in item.list" v-text="v.name"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="coaches flx">
            <div class="coachItem" :class="(index + 1) % 3 == 0?'mr0' :'mr20'" v-for="item,index in list" @click="toDetail(item)">
                <div class="coachImg">
                    <img :src="$img(item.transparent_avatar)" alt="" />
                </div>
                <div class="ppmask">
                    <img :src="$Localimg('dsppmask.png')" alt="" />
                </div>
                <div class="coachinfos">
                    <div class="coachNames">
                        <div class="coachName" v-text="item.name"></div>
                    </div>
                     <div class="coaIntro" v-text="item.title"></div>
                    <div class="labels flx alc">
                        <div class="label" v-text="v.name" v-for="v,i in item.label"></div>
                    </div>
                    <div class="goodat single" v-text="`擅长领域:${item.good_at}`"></div>
                    <div class="pos" v-text="`常住地: ${item.city_name}`"></div>
                </div>
                <div class="asknow">
                    马上咨询
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
       getCoachBanner,
       getCoachList
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
                cates:[],
                banner:[],
                list:[],
                page:1,
                scans:{
                    industry_id:"0",
                    job_id:"0",
                    sex:'0'
                }
            };
        },
        created() {
            this.getBanner()
        },
        methods: {
            toDetail(d){
                let that = this
                this.$router.push({
                    path: '/coachDetail', // 写路由path
                    query: {
                        id:d.id
                    }
                })
            },
            getBanner(){
                let that = this 
                getCoachBanner().then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.banner = res.data.banner
                        that.cates = res.data.where_category
                        that.getList()
                    }
                })
            },
            getList(){
                let that = this 
                let data = that.scans
                data.page = that.page
                data.size = 30
                getCoachList(data).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.list = res.data.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            scanThis(index,id){
                let that = this 
                that.page = 1
                if(index == 0){
                    that.scans.industry_id = id
                }else if (index == 1){
                    that.scans.job_id = id
                }else{
                    that.scans.sex = id
                }
                that.getList()
            }
        }
    };
</script>

<style scoped>
    .asknow{
        width: 92px;
        height: 34px;
        border-radius:17px;
        border: 1px solid #E98926;
        text-align: center;
        line-height: 34px;
        font-size: 14px;
        color: #E98926;
        position: absolute;
        right: 26px;
        bottom: 24px;
        z-index: 99 !important;
        cursor:pointer
    }
    .mr0{
        margin-right: 0 !important;
    }
    .mr20{
        margin-right: 20px !important;
    }
    .coachinfos{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 5;
        box-sizing: border-box;
        padding: 33px 20px;
    }
    .ppmask{
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 4;
        width: 250px;
        
    }
    .ppmask img{
        width: 100%;
        height: 144px;
    }
    .coachImg{
        position: absolute;
        bottom: 12px;
        right: 17px;
        width: 180px;
        height: 222px;
        z-index: 3;
    }
    .coachImg img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .pos{
        text-align: left;
        font-size: 14px;
        color: #53586C;
    }
    .goodat{
        margin-top: 36px;
        font-size: 14px;
        color: #53586C;
        text-align: left;
        margin-bottom: 14px;
        width:60%;
    }
    .labels{
        margin-top: 15px;
    }
    .label{
        font-size: 10px;
        color: #4895FB;
        padding: 2px 6px;
        margin-right: 6px;
        background: #E2EEFE;
        border-radius: 4px;
    }
    .coaIntro{
        font-size: 16px;
        color: #7F3F0F;
        text-align: left;
    }
    .coachName{
        font-weight: 600;
        font-size: 26px;
        color: #222222;
        text-align: left;
        margin-bottom: 17px;
    }
    .coachItem{
        width: 473px;
        height: 250px;
        background: url('https://two.hrxsl.com/pcImages/coachBk.png') no-repeat;
        background-size: 100% 100%; 
       
        flex-shrink: 0;
        position: relative;
        margin-bottom: 20px;
    }
    .coaches{
        width: 1460px;
        margin: 0 auto;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 20px 0;
    }
    .cactive{
        font-weight: 500 !important;
        color: #007AFF !important;
    }
    .caItem{
        margin-right: 40px;
        font-size: 18px;
        color: #4E5366;
        margin-bottom: 0 !important;
    }
    .cateCon{
        flex: 1;
        flex-wrap: wrap;
    }
    .cateName{
        font-weight: 600;
        font-size: 22px;
        color: #222222;
        margin-right: 40px;
    }
    .catesCon{
        width: 1460px;
        margin: 0 auto;
        
    }
    .cateItem{
        padding: 10px 0;
    }
    .cates{
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 12px 0;
    }
</style>